import { createHttpEndpoint } from '../../utils'

import type {
  GetSellerProductDetails,
  PostProductsSellerSearch,
} from './products.types'

/**
 * Retrieves all information about a certain product if it is public or if it was created by the seller doing the query.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/get-bm-catalog-seller-products-id}
 */
export const getSellerProductDetails =
  createHttpEndpoint<GetSellerProductDetails>({
    method: 'GET',
    operationId: 'getSellerProductsSearch',
    path: '/bm/catalog/bo-seller/products/:productId',
  })

/**
 * Search products that are public or created by the seller doing the query
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Products/operation/get-bm-catalog-seller-products-search}
 */
export const postProductsSellerSearch =
  createHttpEndpoint<PostProductsSellerSearch>({
    method: 'POST',
    operationId: 'getSellerProductsSearch',
    path: '/bm/catalog/bo-seller/products/search',
  })
